module.exports = __webpack_public_path__ + "img/signin_job_blue.20567332.svg";